import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  messageDeleteRequest,
  messageDeleteSuccess,
  messageDeleteFailure,
} from '../reducers/messageDelete';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/deleteMessage`;

function* messageDeleteAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;
  const messageId = !state.loginReducer.user.isTeamLeader
    ? state.messageContentReducer.selectedMessageId
    : state.teamMembersFullReducer.selectedMessageId;

  const response = yield call(() =>
    axios({
      method: 'delete',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      params: {
        messageId,
      },
    }),
  );

  return response;
}

function* workerMessageDeleteSaga() {
  try {
    const response = yield call(messageDeleteAxios);

    const responseFromMessageDelete = response.data;
    yield put(messageDeleteSuccess(responseFromMessageDelete));
  } catch (error) {
    yield put(messageDeleteFailure(error));
  }
}

export function* watcherMessageDeleteSaga() {
  yield takeLatest(messageDeleteRequest().type, workerMessageDeleteSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/delete_messageDelete.js